import { useFormik } from "formik"
import React, { useContext, useEffect, useState } from "react"
import * as Yup from "yup"

import {
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Table,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap"

import Switch from "react-switch";
import { uId } from "common/utility"
import ToastDialog from "components/Common/ToastDialog"
import CommonDialog from "components/Common/CommonDialog";
import {
  addDealerUser,
  updateDealerUser,
  getDealerUserList,
  editUserStatus
} from "../../../../helpers/UAM/user.helper"
import { useParams } from "react-router"
import { isEmpty } from "lodash"
import { SystemConfigurationContext } from "context/systemConfigContext"
import FullPageLoader from "components/Common/FullPageLoader";

const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 10
      }}
    >
      {" "}
      Inactive
    </div>
  );
};

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingLeft: 4
      }}
    >
      {" "}
      Active
    </div>
  );
};

const TableActionsComponent = ({ props, handleChange }) => {
  const [checked, setChecked] = useState(props.isActive);
  const newObj = props

  useEffect(() => {
    setChecked(props.isActive);
  }, [props]);

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <Switch
          uncheckedIcon={<Offsymbol />}
          checkedIcon={<OnSymbol />}
          className="me-1 mb-sm-8 mb-2"
          onColor="#344fa0"
          width={80}
          onChange={() => {
            newObj.isActive = !newObj.isActive;
            setChecked(newObj.isActive);
            handleChange(newObj);
          }}
          checked={checked}
        />
      </DropdownToggle>
    </UncontrolledDropdown>
  );
};


const Contacts = ({ dealerData }) => {
  const { id } = useParams()
  const dealerId = !isEmpty(id) ? atob(id) : null

  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isAddAddressOpen, setAddAddressOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [userList, setUserList] = useState([])
  const [userEditData, setUserEditData] = useState([])
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const {inputMax} = useContext(SystemConfigurationContext)
  const [isLoading, setIsLoading] = useState(false);

  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      firstName: (userEditData && userEditData[0]?.firstName) || "",
      lastName: (userEditData && userEditData[0]?.lastName) || "",
      email: (userEditData && userEditData[0]?.email) || "",
      mobileNo: (userEditData && userEditData[0]?.mobileNo) || "",
      id: (userEditData && userEditData[0]?.id) || "",
      roleId: (userEditData && userEditData[0]?.roleId) || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please Enter First Name"),
      lastName: Yup.string().required("Please Enter Last Name"),
      email: Yup.string().required("Please Enter email"),
      mobileNo: Yup.string()
        .required("Please Mobile Number")
        .matches(/^\d{10}$/, "Mobile Number must be exactly 10 digits"),
    }),
    onSubmit: values => {
      if (isEdit) {
        updateDealerUsers(values)
      } else {
        addDealerUsers(values)
      }
    },
  })

  const updateDealerUsers = (values) => {
    setLoading(true);
    setIsLoading(true)
    const dealerUser = {
      id: values.id,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phone: values.mobileNo,
      entityId: dealerId,
      region: dealerData?.region,
    }

    updateDealerUser(dealerUser)
      .then(response => {
        if (response.code == 201 && response.status) {
          validation.resetForm()
          setLoading(false);
          setIsLoading(false);
          setToastInfo({
            message: "User Saved",
            showToast: true,
            role: "success",
          })
          getDealerUserList({ entityId: dealerId })
            .then(response => {
              if (response.status) {
                setUserList(response?.data?.data)
              }
              setAddAddressOpen(false)
            })
            .catch(error => {
              console.log(error)
            })
        } else {
          setLoading(false);
          setIsLoading(false)
          const { message } = response
          setToastInfo({
            message: message,
            showToast: true,
            role: "error",
          })
        }
      })
      .catch(error => {
        setLoading(false);
        setIsLoading(false)
        console.log(error)
      })
  }

  const addDealerUsers = (values) => {
    setLoading(true);
    setIsLoading(true);
    const dealerUser = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phone: values.mobileNo,
      entityId: dealerId,
      region: dealerData?.region,
    }
    addDealerUser(dealerUser)
      .then(response => {
        if (response.status) {
          validation.resetForm()
          setLoading(false);
          setIsLoading(false);
          setToastInfo({
            message: "User Saved",
            showToast: true,
            role: "success",
          })
          getDealerUserList({ entityId: dealerId })
            .then(response => {
              if (response.status) {
                setUserList(response?.data?.data)
              }
            })
            .catch(error => {
              console.log(error)
            })
          setAddAddressOpen(false)
        } else {
          setLoading(false);
          setIsLoading(false);
          const { message } = response
          setToastInfo({
            message: message,
            showToast: true,
            role: "error",
          })
        }
      })
      .catch(error => {
        setLoading(false);
        setIsLoading(false);
        console.log(error)
      })
  }

  useEffect(() => {
    getDealerUserList({ entityId: dealerId })
      .then(response => {
        if (response.status) {
          setUserList(response?.data?.data)
        }
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  const handleCustomerClicks = () => {
    setAddAddressOpen(true)
    setIsEdit(false)
    setUserEditData(null)
  }

  const handleCancelrClicks = () => {
    setAddAddressOpen(false)
    setUserEditData(null)
    validation.resetForm()
  }

  const EditAddress = id => {
    setIsEdit(true)
    const filteredData = userList.filter(elem => {
      return elem.id == id
    })
    setUserEditData(filteredData)
    setAddAddressOpen(true)
  }

  const handleChange = (data) => {
    const message = 'Are you sure want to update user?'
    setShowCommonDialog({ isShow: true, message, data })
  };

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      editUserStatus(data)
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: "User Status Updated",
              showToast: true,
              role: "success",
            });
          } else {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setShowCommonDialog({ isShow: false })
      getDealerUserList({ entityId: dealerId })
        .then(response => {
          if (response.status) {
            setUserList(response?.data?.data)
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
  return (
    <div>
      {isLoading && <FullPageLoader />}
      <div>
        {isAddAddressOpen && (
          <Row className="mb-3">
          <Card>
            <CardBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <div>
                  <h4 style={{ marginTop: "1%" }}> User Details</h4>
                </div>

                <Row className="mb-3">
                  <Col sm="12" md="6">
                    <Label className="form-label mt-4 required">First Name</Label>
                    <Input
                      maxLength={inputMax}
                      name="firstName"
                      type="text"
                      placeholder="Enter First Name"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.firstName || ""}
                      invalid={
                        validation.touched.firstName &&
                        validation.errors.firstName
                      }
                    />
                    {validation.touched.firstName &&
                      validation.errors.firstName ? (
                      <FormFeedback type="invalid">
                        {validation.errors.firstName}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Col sm="12" md="6">
                    <Label className="form-label mt-4 required">Last Name</Label>
                    <Input
                      maxLength={inputMax}
                      name="lastName"
                      type="text"
                      placeholder="Enter Last Name"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.lastName || ""}
                      invalid={
                        validation.touched.lastName &&
                        validation.errors.lastName
                      }
                    />
                    {validation.touched.lastName &&
                      validation.errors.lastName ? (
                      <FormFeedback type="invalid">
                        {validation.errors.lastName}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Col sm="12" md="6">
                    <Label className="form-label mt-4 required">Email</Label>
                    <Input
                      maxLength={inputMax}
                      name="email"
                      type="email"
                      placeholder="Enter Email"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                      invalid={
                        validation.touched.email && validation.errors.email
                      }
                    />
                    {validation.touched.email && validation.errors.email ? (
                      <FormFeedback type="invalid">
                        {validation.errors.email}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Col sm="12" md="6">
                    <Label className="form-label mt-4 required">Mobile No.</Label>
                    <Input
                      maxLength={inputMax}
                      name="mobileNo"
                      type="text"
                      placeholder="Enter Mobile No"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.mobileNo || ""}
                      invalid={
                        validation.touched.mobileNo &&
                        validation.errors.mobileNo
                      }
                    />
                    {validation.touched.mobileNo &&
                      validation.errors.mobileNo ? (
                      <FormFeedback type="invalid">
                        {validation.errors.mobileNo}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <button
                        type="button"
                        className="btn btn-outline-secondary save-customer me-2"
                        onClick={handleCancelrClicks}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-success save-customer"
                      >
                        {loading && (
                          <span
                            className="spinner-border spinner-border-sm ms-2 me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                        {loading && <span>Saving</span>}
                        {!loading && <span>Save</span>}
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
          </Row>
        )}
        <Row>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="card-title">Users</h4>
          <div className="text-sm-end">
              <Button
                type="button"
                color="success"
                className="btn-rounded mb-2 me-2"
                onClick={handleCustomerClicks}
              >
                <i className="mdi mdi-plus me-1" />
                New User
              </Button>
          </div>
          </div>
          <Col xs="12">
            <div className="table-responsive">
              <Table className="table table-bordered mb-0 ">
                <thead className="table-light">
                  <tr>
                    <th>Id</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>User Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {userList.length == 0 ? (
                    <tr>
                      <td colSpan={7} className="text-center">
                        No data found
                      </td>
                    </tr>
                  ) : (
                    userList.map((elem, index) => (
                      <tr key={uId()} >
                        <td
                          className={`${index % 2 == 0
                            ? "table-row-odd"
                            : "table-row-even"
                            }`}>{index + 1}</td>
                        <td
                          className={`${index % 2 == 0
                            ? "table-row-odd"
                            : "table-row-even"
                            }`}>{elem.firstName || "-"}</td>
                        <td
                          className={`${index % 2 == 0
                            ? "table-row-odd"
                            : "table-row-even"
                            }`}>{elem.lastName || "-"}</td>
                        <td
                          className={`${index % 2 == 0
                            ? "table-row-odd"
                            : "table-row-even"
                            }`}>{elem.email}</td>
                        <td
                          className={`${index % 2 == 0
                            ? "table-row-odd"
                            : "table-row-even"
                            }`}>{elem.mobileNo}</td>
                        <td
                          className={`${index % 2 == 0
                            ? "table-row-odd"
                            : "table-row-even"
                            }`}>
                          <TableActionsComponent
                            props={elem}
                            handleChange={(newObj) => {
                              handleChange(newObj);
                            }}
                          />
                        </td>

                        <td
                          className={`${index % 2 == 0
                            ? "table-row-odd"
                            : "table-row-even"
                            }`}>
                          <UncontrolledDropdown>
                            <DropdownToggle tag="a" className="card-drop">
                              <i className="mdi mdi-dots-horizontal font-size-18"></i>
                            </DropdownToggle>

                            <DropdownMenu className="dropdown-menu-end">
                              <DropdownItem
                                onClick={() => {
                                  EditAddress(elem.id)
                                }}
                              >
                                <i
                                  className="mdi mdi-pencil font-size-16 text-success me-1"
                                  id="edittooltip"
                                ></i>
                                Edit
                                <UncontrolledTooltip
                                  placement="top"
                                  target="edittooltip"
                                >
                                  Edit
                                </UncontrolledTooltip>
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      {
        showCommonDialog &&
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message} data={showCommonDialog.data}
          postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}
        />
      }
    </div>
  )
}

export default Contacts
